import {
  SHORTLIST_TEMP_ITEM_PROGRESS_UPDATE,
  SHORTLIST_TEMP_ITEM_UPDATE,
  TRACK_PLAY_PROGRESS_UPDATE,
} from '@disco/constants/ActionTypes'
import debug from 'debug'
import captureError from '@disco/utils/captureError'
const ignoreList = [
  SHORTLIST_TEMP_ITEM_UPDATE,
  SHORTLIST_TEMP_ITEM_PROGRESS_UPDATE,
  TRACK_PLAY_PROGRESS_UPDATE,
]

const errorReporter = (store: any) => (next: any) => (action: any) => {
  try {
    if (action.type && ignoreList.indexOf(action.type) === -1) {
      // TODO: move to datadog or delete?
      // Sentry.addBreadcrumb({
      //   message: action.type,
      //   category: 'action',
      //   level: 'info',
      //   data: action.payload,
      // })
    }

    return next(action)
  } catch (err) {
    // Report error in case it is ignored in action
    debug('middleware.errorReporter')(action, store.getState(), err)
    captureError(err as Error, { extra: action })
    throw err
  }
}

export default errorReporter
